module.exports = __webpack_public_path__ + "static/media/tools-activities.9ed99893.svg";